var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyNowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88281 0.422894C1.6176 0.422894 1.36324 0.528251 1.17571 0.715787C0.988169 0.903324 0.882813 1.15768 0.882812 1.42289C0.882813 1.68811 0.988169 1.94246 1.17571 2.13C1.36324 2.31754 1.6176 2.42289 1.88281 2.42289H4.10281L6.72681 12.9229C6.94981 13.8129 7.74681 14.4229 8.66381 14.4229H21.1338C22.0368 14.4229 22.8038 13.8229 23.0408 12.9529L25.6328 3.42289H23.5388L21.1328 12.4229H8.66281L6.03981 1.92289C5.93146 1.49212 5.68169 1.11017 5.33049 0.838207C4.97929 0.566243 4.54699 0.419999 4.10281 0.422894H1.88281ZM19.8828 14.4229C18.2378 14.4229 16.8828 15.7779 16.8828 17.4229C16.8828 19.0679 18.2378 20.4229 19.8828 20.4229C21.5278 20.4229 22.8828 19.0679 22.8828 17.4229C22.8828 15.7779 21.5278 14.4229 19.8828 14.4229ZM10.8828 14.4229C9.23781 14.4229 7.88281 15.7779 7.88281 17.4229C7.88281 19.0679 9.23781 20.4229 10.8828 20.4229C12.5278 20.4229 13.8828 19.0679 13.8828 17.4229C13.8828 15.7779 12.5278 14.4229 10.8828 14.4229ZM13.8828 0.422894V5.42289H10.8828L14.8828 9.42289L18.8828 5.42289H15.8828V0.422894H13.8828ZM10.8828 16.4229C11.4468 16.4229 11.8828 16.8589 11.8828 17.4229C11.8828 17.9869 11.4468 18.4229 10.8828 18.4229C10.3188 18.4229 9.88281 17.9869 9.88281 17.4229C9.88281 16.8589 10.3188 16.4229 10.8828 16.4229ZM19.8828 16.4229C20.4468 16.4229 20.8828 16.8589 20.8828 17.4229C20.8828 17.9869 20.4468 18.4229 19.8828 18.4229C19.3188 18.4229 18.8828 17.9869 18.8828 17.4229C18.8828 16.8589 19.3188 16.4229 19.8828 16.4229Z",
    fill: "url(#paint0_linear_328_15481)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_15481",
    x1: 0.882812,
    y1: 10.4229,
    x2: 25.6328,
    y2: 10.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8F68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CFFCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyNowIcon);
export default __webpack_public_path__ + "static/media/buyNowIcon.c0ba1faa148ccaf98b539b5eeb3a3f86.svg";
export { ForwardRef as ReactComponent };